{
  "version": 1,
  "asset_id": "076ec3a4-5139-4f9a-b81b-948b3d0d8616",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/076ec3a4-5139-4f9a-b81b-948b3d0d8616/loc-plano-1280.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/076ec3a4-5139-4f9a-b81b-948b3d0d8616/loc-plano-1280.webp",
  "original_filename": "loc-plano-1280.webp",
  "size": 97170,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:31Z"
}
